import { type PropsWithChildren } from 'react'

import styles from './AudioAiMasteringSection.module.css'

type TAudioAiMasteringSectionProps = PropsWithChildren<{ heading: string }>

export const AudioAiMasteringSection = ({ heading, children }: TAudioAiMasteringSectionProps) => (
    <section className={styles.section}>
        <h2 className={styles.heading}>{heading}</h2>
        {children}
    </section>
)
